import { Component, OnInit } from '@angular/core';
import { SingUpService } from '../services/signup.service';
import { SharedService } from '../services1/shared.service';
import Swal from 'sweetalert2';
import { NavigationStart, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  hideFooter: boolean = false;

  contact: string = '';
  message: { text: string; type: string; icon: string } = {
    text: '',
    type: '',
    icon: '',
  };
  currentYear: number = new Date().getFullYear();
  constructor(
    private signUpService: SingUpService,
    private sharedService: SharedService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.sharedService.hideFooter$.subscribe(() => {
      this.hideFooter = false;
      setTimeout(() => {
        this.hideFooter = true;
      }, 1000);
    });

    setTimeout(() => {
      this.hideFooter = true;
    }, 1000);

    this.router.events
      .pipe(filter((event) => event instanceof NavigationStart))
      .subscribe(() => {
        this.clearMessage();
      });
  }
  clearMessage() {
    this.message = { text: '', type: '', icon: '' };
    this.contact = '';
  }

  activateSignUpPopUp(isEnable: boolean) {
    this.signUpService.EnableSignUpModel(isEnable);
  }
  subscribeBtn() {
    if (!this.contact) {
      this.message = {
        text: 'Please Enter Your Email .',
        type: 'text-warning',
        icon: 'fa-solid fa-circle-exclamation',
      };
      return;
    }

    const payload = { contact: this.contact };
    this.sharedService.subscriptionService(payload).subscribe({
      next: (response: any) => {
        if (response?.status) {
          this.message = {
            text: response?.message || 'Subscribed successfully!',
            type: 'text-success',
            icon: 'fa-solid fa-circle-check',
          };
          this.contact = '';
        } else {
          this.message = {
            text: response?.message || 'Invalid Email Format.',
            type: 'text-info',
            icon: 'fa-solid fa-circle-exclamation',
          };
        }
      },
      error: () => {
        this.message = {
          text: 'Something went wrong. Please try again later.',
          type: 'text-danger',
          icon: 'fa-solid fa-circle-xmark',
        };
      },
    });
  }
}
